import { MessageSquare, Bot, Database, Calendar, History } from "lucide-react";

const Process = () => {
  const steps = [
    {
      step: "PASSO 1",
      title: "Lead via WhatsApp",
      description: "Lead chega pelo canal de WhatsApp",
      icon: MessageSquare,
      position: "right"
    },
    {
      step: "PASSO 2", 
      title: "IA triagem e qualificação",
      description: "IA faz a triagem, responde e qualifica o lead",
      icon: Bot,
      position: "left"
    },
    {
      step: "PASSO 3",
      title: "Dados no CRM", 
      description: "Dados capturados automaticamente e registrados no CRM",
      icon: Database,
      position: "right"
    },
    {
      step: "PASSO 4",
      title: "Agendamento/Encaminhamento",
      description: "Agendamento automático ou encaminhamento ao vendedor", 
      icon: Calendar,
      position: "left"
    },
    {
      step: "PASSO 5",
      title: "Histórico centralizado",
      description: "Histórico da jornada do lead fica acessível",
      icon: History,
      position: "right"
    }
  ];

  return (
    <section id="funcionalidades" className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-heading text-foreground mb-6">
            Como o agente SDR{" "}
            <span className="bg-gradient-hero bg-clip-text text-transparent">
              funciona na prática
            </span>
          </h2>
          <p className="text-body-large text-muted-foreground max-w-3xl mx-auto">
            Visualize o fluxo do processo de criação: do primeiro contato até o histórico centralizado.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-gradient-to-b from-primary/50 via-primary to-primary/50" />
          
          {/* Steps */}
          <div className="space-y-12">
            {steps.map((step, index) => {
              const Icon = step.icon;
              const isLeft = step.position === "left";
              
              return (
                <div key={index} className="relative flex items-center">
                  {/* Timeline Dot */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-primary rounded-full border-4 border-background shadow-soft z-10" />
                  
                  {/* Content */}
                  <div className={`w-full md:w-5/12 ${isLeft ? 'md:mr-auto md:pr-8' : 'md:ml-auto md:pl-8'} ${isLeft ? 'md:text-right' : ''}`}>
                    <div className={`bg-card rounded-2xl p-5 border border-border/50 shadow-soft hover:shadow-hover transition-all duration-300 ${isLeft ? 'md:ml-0' : 'md:mr-0'} mx-4 md:mx-0`}>
                      {/* Step Badge */}
                      <div className="badge-accessible mb-3">
                        {step.step}
                      </div>
                      
                      {/* Icon and Title */}
                      <div className={`flex items-center gap-3 mb-2 ${isLeft ? 'md:justify-end' : ''}`}>
                        <div className={`${isLeft ? 'md:order-2' : ''}`}>
                          <div className="flex items-center justify-center w-12 h-12 bg-accent/20 rounded-xl">
                            <Icon size={24} className="text-secondary" />
                          </div>
                        </div>
                        <h3 className={`text-xl font-semibold text-foreground ${isLeft ? 'md:order-1' : ''}`}>
                          {step.title}
                        </h3>
                      </div>
                      
                      {/* Description */}
                      <p className="text-muted-foreground">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;